module.exports = __webpack_public_path__ + "img/wx1.f0f496b6.jpg";